import React from 'react'
import { Link } from 'react-router'
import store from './FbackList/orderForm/store'

export default [
  {
    title: '推荐号',
    dataIndex: 'account',
    key: 'account',
    render: (text, record) => <span>{record.order_sub.order_no}</span>
  },
  {
    title: '类型',
    dataIndex: 'type',
    key: 'type',
    render: (text, record) => {
      let _type = '暂无'
      switch (String(record.status)) {
        case '0':
          _type = '定金已付'
          break
        case '1':
          _type = '定金已付'
          break
        case '2':
          _type = '定金已付 '
          break
        case '3':
          _type = '退单'
          break
        case '4':
          _type = '退单'
          break
        case '5':
          _type = '退单'
          break
      }
      return <span>{_type}</span>
    }
  },
  {
    title: '审核状态',
    dataIndex: 'status',
    key: 'status',
    render: (text, record) => {
      let _type = '暂无'
      let _reason = ''
      let _reasonCont = ''
      switch (String(record.status)) {
        case '0':
          _type = '成单提交'
          break
        case '1':
          _type = '成单通过'
          break
        case '2':
          _type = '成单不通过 '
          _reason = '(查看原因)'
          _reasonCont = record.audit_reason

          break
        case '3':
          _type = '退单提交'
          break
        case '4':
          _type = '退单通过'
          break
        case '5':
          _type = '退单不通过'
          _reason = '(查看原因)'
          _reasonCont = record.audit_reason
          break
      }
      store.id = record.id

      return (
        <div>
          <p>{_type}</p>
          <a href="javascript:;" onClick={store.reasonInfo(_reasonCont)}>
            {_reason}
          </a>
        </div>
      )
    }
  },
  {
    title: '客户/电话',
    dataIndex: 'phone',
    key: 'phone',
    render: (text, record) => {
      return (
        <div>
          <p>{record.lead.name}</p>
          <p>{record.lead.phone}</p>
        </div>
      )
    }
  },
  {
    title: '金额',
    dataIndex: 'price',
    key: 'price',
    render: (text, record) => {
      return <span>{record.contract_money}</span>
    }
  },
  {
    title: '婚宴时间',
    dataIndex: 'weddingData',
    key: 'weddingData',
    render: (text, record) => {
      return <span>{record.wedding_day}</span>
    }
  },
  {
    title: '提交时间',
    dataIndex: 'sendData',
    key: 'sendData',
    render: (text, record) => {
      let _type = '暂无'
      switch (String(record.status)) {
        case '0':
          _type = record.feedback_at
          break
        case '1':
          _type = record.feedback_at
          break
        case '2':
          _type = record.feedback_at
          break
        case '3':
          _type = record.refund_at
          break
        case '4':
          _type = record.refund_at
          break
        case '5':
          _type = record.refund_at
          break
      }
      return <span>{_type}</span>
    }
  },
  {
    title: '操作',
    key: 'action',
    render: (text, record) => {
      let _type = ''
      switch (String(record.status)) {
        case '2':
          _type = '补单'
          break
        case '5':
          //_type='补单'
          break
      }

      return (
        <div>
          <p>
            <Link to={`/localMerchant/myOrder/info/${record.id}`}>查看</Link>
          </p>
          <a
            id={record.id}
            onClick={store.showModal(record.id)}
            href="javascript:;"
          >
            {_type}
          </a>
        </div>
      )
    }
  }
]
